<div class="container my-4">
    <div class="row">
        <div class="col-12 commission_report">
            <div class="title_header_bar">
                Additional Information Report
            </div>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="additionalInfoReportForm">
            <div class="row">
                <div class="col-12 ml-2 d-flex justify-content-start">
                    <!-- <button class="btn btn-secondary" (click)="Reset()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="Reset()"></app-button>

                </div>
                <div class="col-xl-1"></div>
                <div class="col-xl-10">
                    <div class="row">
                        <div class="col-xl-12 mt-4 text-center commission_report">
                            <mat-label class="mr-3" [style.color]="!this.additionalInfoReportForm.value.isCancellationDate?'#7f15d1':'black'">Cancellation Date</mat-label>
                           <mat-slide-toggle formControlName="isCancellationDate" color="primary">
                           <mat-label class="ml-2" [style.color]="!this.additionalInfoReportForm.value.isCancellationDate?'black':'#7f15d1'"> Required Service Date </mat-label>
                           </mat-slide-toggle>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>{{!this.additionalInfoReportForm.value.isCancellationDate?'Cancellation Start Date':'Require Service Start Date'}}</mat-label>
                                <input readonly matInput appInputtext [matDatepicker]="startDate"
                                    formControlName="startDate" selectable="isSelectable(date,type)" id="startDate"
                                    autocomplete="off" placeholder="Select From Date" class="custom-input-border"
                                    specialIsAlphaNumeric (click)="openStartDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>{{!this.additionalInfoReportForm.value.isCancellationDate?'Cancellation End Date':'Require Service End Date'}}</mat-label>
                                <input readonly matInput appInputtext [matDatepicker]="endDate"
                                    formControlName="endDate" selectable="isSelectable(date,type)" id="endDate"
                                    autocomplete="off" [min]="toMinDate" [max]="toMaxDate" placeholder="Select To Date"
                                    class="custom-input-border" specialIsAlphaNumeric (click)="openEndDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #endDate></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-12 mt-5 d-flex justify-content-center">
                            <button class="btn btn-primary mr-3"
                                (click)="generateExcel()">
                                <i class="fa fa-file-excel mr-1"></i> Generate Report
                            </button>
             
                        </div>
       
                    </div>
                </div>
                <div class="col-xl-1"></div>

            </div>
        </form>

    </div>
</div>
